// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"e0bf19a5","267":"f08ef84d","396":"f5850a4e","755":"79899e14"}[chunkId] + ".chunk.css";
};